import React from "react";

export const headingLevelContext = React.createContext({ level: 1 });

export const H = ({
    children,
    ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => {
    const { level } = React.useContext(headingLevelContext);

    if (level < 1) {
        const e = new Error("Heading level must be positive");
        if (process.env.NODE_ENV !== "production") {
            throw e;
        } else {
            console.error(e);
        }
    }

    if (level > 6) {
        console.warn(
            "The HTML spec recommends sticking to the built-in heading levels (1-6",
        );
        return <div {...props} role="heading" aria-level={level} />;
    } else {
        return React.createElement(`h${level}`, props, children);
    }
};

export const HLevel = ({
    children,
    level,
}: React.PropsWithChildren<{ level?: number }>) => {
    const context = React.useContext(headingLevelContext);
    level = typeof level === "number" ? level : context.level + 1;
    return (
        <headingLevelContext.Provider value={{ level }}>
            {children}
        </headingLevelContext.Provider>
    );
};
